<template>
   <div>
      <v-snackbar
         v-for="(snackbar, index) in snackbarStackCopy"
         :key="snackbar.id"
         v-model="snackbar.visible"
         :timeout="snackbar.timeout"
         :color="snackbar.type"
         location="top"
         rounded="lg"
         :style="{top: `${index * 60}px`}"
         @update:model-value="onSnackbarInput(snackbar.id, $event)"
      >
         {{ snackbar.message }}
         <template v-if="snackbar.onUndo != null" #actions>
            <v-btn variant="text" @click="onUndoClick(snackbar)">Undo</v-btn>
         </template>
      </v-snackbar>
   </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import type {ISnackbarData} from './dialog_service';
import {gDialogService} from './dialog_service';

export default defineComponent({
   data() {
      return {
         snackbarStackCopy: [] as ISnackbarData[],
      };
   },
   mounted() {
      // The service is not reactive; copy its stack on every change
      gDialogService.addCallback(() => {
         this.snackbarStackCopy = [...gDialogService.getSnackbarStack()];
      });
   },
   methods: {
      /** Dismiss the toast, then run its undo. */
      onUndoClick(snackbar: ISnackbarData) {
         gDialogService.removeSnackbar(snackbar.id);
         snackbar.onUndo?.();
      },

      onSnackbarInput(id: string, isVisible: boolean) {
         // When the snackbar hides itself, remove it from the service
         if (!isVisible) {
            // Let the hide animation finish before removing
            setTimeout(() => {
               gDialogService.removeSnackbar(id);
            }, 200);
         }
      },
   },
});
</script>
